/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FloorplanHistoryDto } from '../../models/floorplan-history-dto';

export interface FloorplanControllerFindHistory$Params {
  id: string;
  clientWorkspaceId: string;
  take?: number;
}

export function floorplanControllerFindHistory(http: HttpClient, rootUrl: string, params: FloorplanControllerFindHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FloorplanHistoryDto>>> {
  const rb = new RequestBuilder(rootUrl, floorplanControllerFindHistory.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
    rb.query('take', params.take, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FloorplanHistoryDto>>;
    })
  );
}

floorplanControllerFindHistory.PATH = '/api/floorplan/{clientWorkspaceId}/{id}/history';
